// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { AddLocationDialogComponent } from './add-location-dialog/add-location-dialog.component';
import { DynamicSelectDialogComponent } from '../shared/dialogs/dynamic-select-dialog/dynamic-select-dialog.component';
import { EmailJdrDialogComponent } from './email-jdr-dialog/email-jdr-dialog.component';
import { UnitConfigChannelAddDialogComponent } from '../modules/unit-config/dialogs/unit-config-channel-add-dialog/unit-config-channel-add-dialog.component';
import { RunningFootageDialogComponent } from './running-footage-dialog/running-footage-dialog.component';
import { OutputConfigChannelAddDialogComponent } from '../modules/output-config/dialogs/output-config-channel-add-dialog/output-config-channel-add-dialog.component';
import { ChangePasswordAdminDialogComponent } from '../modules/company/dialogs/change-password-admin-dialog/change-password-admin-dialog.component';
import { ConnectionStatusDialogComponent } from '../shared/components/online-indicator/dialogs/connection-status-dialog/connection-status-dialog.component';

// Modules
import { SharedModule } from '../shared';
import { CoreModule } from '../core.module';
import { ChannelExpressionDialogComponent } from '../modules/unit-config/dialogs/channel-expression-dialog/channel-expression-dialog.component';

@NgModule({
	imports: [CommonModule, CoreModule, SharedModule],
	declarations: [AddLocationDialogComponent, ConnectionStatusDialogComponent, DynamicSelectDialogComponent, EmailJdrDialogComponent, UnitConfigChannelAddDialogComponent, OutputConfigChannelAddDialogComponent, ChannelExpressionDialogComponent, RunningFootageDialogComponent, ChangePasswordAdminDialogComponent],
	exports: [AddLocationDialogComponent, ConnectionStatusDialogComponent, DynamicSelectDialogComponent, EmailJdrDialogComponent, UnitConfigChannelAddDialogComponent, OutputConfigChannelAddDialogComponent, ChangePasswordAdminDialogComponent],
})
export class DialogsModule {}
